import { motion } from "framer-motion";
import { MessageSquare, Paintbrush, Rocket, ArrowRight } from "lucide-react";

const steps = [
  {
    icon: MessageSquare,
    step: "01",
    title: "On échange",
    description: "Vous me décrivez votre profil, votre métier et vos attentes. Je vous propose la formule adaptée.",
    duration: "15 min",
  },
  {
    icon: Paintbrush,
    step: "02",
    title: "Je personnalise",
    description: "Je configure votre portfolio avec vos couleurs, vos textes, vos photos et vos expériences.",
    duration: "24-72h",
  },
  {
    icon: Rocket,
    step: "03",
    title: "C'est en ligne",
    description: "Votre portfolio est déployé, optimisé SEO, et prêt à impressionner vos visiteurs et prospects.",
    duration: "Immédiat",
  },
];

const SellProcess = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-6">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Comment ça marche
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4">
            Votre portfolio en{" "}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">3 étapes</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Simple, rapide, sans prise de tête
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 relative">
            {/* Connecting line */}
            <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-0.5 bg-gradient-to-r from-primary/30 via-accent/30 to-primary/30" />
            
            {steps.map((step, i) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.2 }}
                className="relative text-center"
              >
                <div className="relative inline-flex mb-6">
                  <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg shadow-primary/20">
                    <step.icon className="w-9 h-9 text-primary-foreground" />
                  </div>
                  <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-card border-2 border-primary flex items-center justify-center text-xs font-bold text-primary">
                    {step.step}
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-3">{step.description}</p>
                <span className="inline-flex px-3 py-1 rounded-full bg-secondary text-xs font-medium text-muted-foreground">
                  ⏱ {step.duration}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellProcess;
